/**
 *
 * key
 *
 */

 const key = 'bXlCb29raW5nQ29tcGxldGU='

 export default key
 